import { Component , TemplateRef, ViewChild, PLATFORM_ID ,Inject, OnInit} from '@angular/core';
import { CommonModule,isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { MatDialogModule,MAT_DIALOG_DATA,MatDialogRef } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

import { FacadeService } from '../../services/facade.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { MatDialog } from '@angular/material/dialog';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-modal-cancel-subscription',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    HttpClientModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    FormsModule],
  templateUrl: './modal-cancel-subscription.component.html',
  styleUrl: './modal-cancel-subscription.component.css'
})
export class ModalCancelSubscriptionComponent {

  name: string;
  isProcessing: boolean = false;
  errorMsg: string | null = null;


 constructor(
    public dialogRef: MatDialogRef<ModalCancelSubscriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    public fachada: FacadeService,
    private http: HttpClient,
  ) {
    this.name = data?.name ?? '';
   
  }
  async confirmRemove() {
    if (this.isProcessing) return;

    this.isProcessing = true;
    this.errorMsg = null;

    try {
      await this.fachada.deleteUserSubs(this.http);
      this.dialogRef.close(true);
    } catch (error: any) {
      console.error('Error al cancelar la suscripción', error);

      this.errorMsg =
        error?.error?.msg ||
        'An unexpected error occurred. Please try again.';

      this.isProcessing = false;
    }
  }

  get isUpgradeWarning(): boolean {
    return this.data?.mode === 'upgrade-warning';
  }

  get normalizedPaymentName(): string {
    return String(this.name || '').trim().toLowerCase();
  }

  get isStripePayment(): boolean {
    return this.normalizedPaymentName === 'stripe';
  }

  get isPaypalPayment(): boolean {
    return this.normalizedPaymentName === 'paypal';
  }

  get canCancelRenewal(): boolean {
    return !this.isUpgradeWarning && !this.isPaypalPayment;
  }

}
